export default {
  name: 'RtUpload',
  render(h) {
    return h(
      'el-upload',
      {
        attrs: this.$attrs,
        props: this.$props,
        ref: 'upload'
      },
      [this.$slots.default, this.$slots.tip, this.$slots.trigger]
    );
  },
  methods: {
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
    abort(file) {
      this.$refs.upload.abort(file);
    },
    submit() {
      this.$refs.upload.submit();
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/upload/rtUpload.js